const AUTH_PARAM_KEYS = [
  'ekid',
  'enpd',
  'enfd',
  'cmac',
  'rid',
  'p',
  'c',
  'm',
  'original_url',
  'type',
];

function removeAuthParamsFromSearch(search) {
  const queryParams = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );

  AUTH_PARAM_KEYS.forEach((key) => queryParams.delete(key));

  const nextSearch = queryParams.toString();

  return nextSearch ? `?${nextSearch}` : '';
}

function removeAuthParamsFromHash(hash) {
  if (!hash) {
    return '';
  }

  const hashWithoutPrefix = hash.startsWith('#') ? hash.slice(1) : hash;
  const queryStartIndex = hashWithoutPrefix.indexOf('?');

  if (queryStartIndex === -1) {
    return hash;
  }

  const hashPath = hashWithoutPrefix.slice(0, queryStartIndex);
  const hashSearch = hashWithoutPrefix.slice(queryStartIndex + 1);
  const nextHashSearch = removeAuthParamsFromSearch(hashSearch);

  return `#${hashPath}${nextHashSearch}`;
}

export function hasV1AuthParams({ ekid, enpd, enfd, cmac } = {}) {
  return [ekid, enpd, enfd, cmac].every((value) => value !== null);
}

export function hasV2AuthParams({ rid, p, c, m } = {}) {
  return [rid, p, c, m].every((value) => value !== null);
}

export function hasAnyAuthParams(authParams = {}) {
  return hasV1AuthParams(authParams) || hasV2AuthParams(authParams);
}

export function clearAuthParams() {
  const url = new URL(window.location.href);

  const nextHash = removeAuthParamsFromHash(url.hash);

  // Clear all query params before the hash.
  // Example:
  // /?type=sc#/watch -> /#/watch
  const nextUrl = `${url.pathname}${nextHash}`;

  window.history.replaceState(window.history.state, '', nextUrl);
}
